import { status } from './../../common/constants';
import { createAction } from '@reduxjs/toolkit';

const FETCHING_CLASS_LIST = 'FETCHING_CLASS_LIST';
const FETCHING_CLASS_LIST_SUCCESS = 'FETCHING_CLASS_LIST_SUCCESS';
const FETCHING_CLASS_LIST_FAILURE = 'FETCHING_CLASS_LIST_FAILURE';
const CREATE_CLASS = 'SCREATE_CLASS';
const GET_CLASS_DETAIL = 'GET_CLASS_DETAIL';
const UPDATE_CLASS = 'UPDATE_CLASS';
const CLEAR_CLASS = 'CLEAR_CLASS';
const FETCH_CLASS_MODULES_LIST = 'FETCH_CLASS_MODULES_LIST';
const FETCH_CLASS_MODULES = 'FETCH_CLASS_MODULES';
const FETCH_CLASS_MODULES_EVERY = 'FETCH_CLASS_MODULES_EVERY';
const CLASS_FETCHING_PROVINCE_LIST = 'FETCHING_PROVINCE_LIST';
const CLASS_FETCHING_DISTRICT_LIST = 'CLASS_FETCHING_DISTRICT_LIST';
const CLASS_FETCHING_WARD_LIST = 'FETCHING_WARD_LIST';
const CLASS_FETCHING_SCHOOL_LIST = 'CLASS_FETCHING_SCHOOL_LIST';
const ADD_CLASS_MODULE = 'ADD_CLASS_MODULE';
const REMOVE_CLASS_MODULE = 'REMOVE_CLASS_MODULE';
const ADD_CLASS_STUDENTS = 'ADD_CLASS_STUDENTS';
const REMOVE_CLASS_STUDENTS = 'REMOVE_CLASS_STUDENTS';
const DOWNLOAD_TEMPLATE_ACCOUNT_CLASS_LIST = 'DOWNLOAD_TEMPLATE_ACCOUNT_CLASS_LIST';
const DOWNLOAD_TEMPLATE_CLASS_IMPORT = 'DOWNLOAD_TEMPLATE_CLASS_IMPORT';
const IMPORT_CLASS_LIST = 'IMPORT_CLASS_LIST';
const FETCH_CLASS_SCHOOL_MODULES = 'FETCH_CLASS_SCHOOL_MODULES';
const DELETE_CLASS = 'DELETE_CLASS';
export interface classListSuccessPayload {
    id?: number | string;
    school: any;
    grade: string | { id: number; name: string };
    code: string;
    name: string;
    school_year?: string;
    student_count?: string;
    head_teacher_name?: string;
    status: 1 | 2;
    created_date: string;
    updated_date: string;
    class_type?: string;
    partner?: number | string | null;
}

export type classModuleProps = {
    id: number;
    name: string;
    en_name: string;
    short_name: string;
    description: string;
    type: string | null;
    syllabus: string;
    exam_duration: number;
    exam_pass_score: number;
    practice_duration: number;
    practice_pass_score: number;
    grades: number[];
    status: 0 | 1;
};

type classDataDetailType = Omit<
    classListSuccessPayload,
    'id' | 'status' | 'created_date' | 'updated_date'
> & {
    /** Curriculum module IDs to assign (class update). */
    module_ids?: number[];
    /** Internal: skip redirect + toast variant after PUT (ListModule bulk assign). */
    __skipRedirect?: boolean;
};

type listClassModuleProps = {
    pageSize?: number,
    page?: number,
    status?: 0 | 1,
    classId?: number
}

export type fetchListClassModuletype = {
    id: number;
    status: number;
    created_date: string;
    updated_date: string;
    module: number;
};

export type edxCourseType = {
    id: number,
    name: string | null,
    description: string | null,
    type: string | null,
    syllabus: string | null,
    exam_duration: number | null,
    exam_pass_score: number | null,
    status: number,
    edx_course_id: string | null,
    edx_course_display_names: string | null,
    created_date: string | null,
    updated_date: string | null
}

export const fetchingClassList = createAction(FETCHING_CLASS_LIST, (filters: any) => ({
    payload: filters,
}));
export const fetchingClassListSuccess = createAction<
    classListSuccessPayload[]
>(FETCHING_CLASS_LIST_SUCCESS);
export const fetchingClassListFailure = createAction(
    FETCHING_CLASS_LIST_FAILURE,
);
export const createClass = createAction<classDataDetailType>(CREATE_CLASS);

export const getClassDetail = createAction(
    GET_CLASS_DETAIL,
    (id: string) => ({
        payload: { id: id },
    }),
);
export const clearClass = createAction(CLEAR_CLASS);

export const updateClass = createAction<any>(
    UPDATE_CLASS,
    (data: classDataDetailType, id: string) => ({
        payload: { data: data, id: id },
    }),
);

export const fetchListClassModules = createAction<any>(
    FETCH_CLASS_MODULES,
    ({ page, pageSize, classId, status }: { page: number, pageSize: number, classId: number, status?: number | null }) => ({
        payload: {
            page: page,
            pageSize: pageSize,
            classId: classId,
            status: status,
        },
    }),
);

export const fetchListClassModulesEvery = createAction<any>(
    FETCH_CLASS_MODULES_EVERY,
    ({ page, pageSize, classId }: { page: number, pageSize: number, classId: number }) => ({
        payload: {
            page: page,
            pageSize: pageSize,
            classId: classId,
        },
    }),
);

export const fetchProviceList = createAction(CLASS_FETCHING_PROVINCE_LIST);
export const fetchClassDistrictList = createAction(CLASS_FETCHING_DISTRICT_LIST, (provinceId: string) => ({
    payload: { provinceId: provinceId }
}));
export const fetchWardList = createAction(CLASS_FETCHING_WARD_LIST, (districtId: string) => ({
    payload: { districtId: districtId }
}));
export const fetchSchoolList = createAction(CLASS_FETCHING_SCHOOL_LIST, (wardId: string, districtId: string, provinceId: string,newWardId?:string,newProvinceId?:string, search?:string,page?:number,page_size?:number) => ({
    payload: { wardId: wardId, districtId: districtId, provinceId: provinceId,newProvinceId, newWardId,search,page,page_size }
}));

export const fetchClassModuleList = createAction(FETCH_CLASS_MODULES_LIST, (classId: string) => ({
    payload: {
        classId: classId
    }
})
)

export const fetchClassSchoolModules = createAction(
    FETCH_CLASS_SCHOOL_MODULES,
    (classId: string | number) => ({
        payload: { classId },
    }),
);
export const addClassModule = createAction(ADD_CLASS_MODULE, (moduleIds: string[], classId: string) => ({
    payload: {
        moduleIds,
        classId
    }
}))

export const removeClassModule = createAction(REMOVE_CLASS_MODULE, (moduleIds: string[], classId: string) => ({
    payload: {
        moduleIds,
        classId
    }
}))

export const addClassStudents = createAction(ADD_CLASS_STUDENTS, (studentIds: string[], classId: string) => ({
    payload: {
        studentIds,
        classId
    }
}))

export const removeClassStudents = createAction(REMOVE_CLASS_STUDENTS, (studentIds: string[], classId: string) => ({
    payload: {
        studentIds,
        classId
    }
}))

export const downloadTemplateAccountClassList = createAction(DOWNLOAD_TEMPLATE_ACCOUNT_CLASS_LIST, (classId: number, schoolId: number) => ({
    payload: {
        classId: classId,
        schoolId: schoolId
    }
}));

export const clearTemplateClassFile = createAction('CLEAR_TEMPLATE_CLASS_FILE');
export const downloadTemplateClassImport = createAction(DOWNLOAD_TEMPLATE_CLASS_IMPORT);
export const importClassList = createAction(IMPORT_CLASS_LIST, (file: File) => ({
    payload: {
        file
    }
}));
export const clearImportClassTemplateFile = createAction('CLEAR_IMPORT_CLASS_TEMPLATE_FILE');
export const clearImportedClassListPreview = createAction('CLEAR_IMPORTED_CLASS_LIST_PREVIEW');

export type DeleteClassPayload = {
  id: string;
};

export const deleteClass = createAction<DeleteClassPayload>(DELETE_CLASS);